import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const baseSwitch: SxStyle = {
  display: 'flex',
  alignItems: 'center',
};

export const name: SxStyle = {
  flexShrink: 0,
  textTransform: 'capitalize',
};

export const icon: SxStyle = {
  color: (p) => p.palette.grey[400],
  cursor: 'pointer',

  '&:hover': {
    color: (p) => p.palette.grey[800],
  },
};
